import styled from 'styled-components';

import 'styles/global';

export const Wrapper = styled.div<{
  backgroundImage?: string;
  isMobile?: boolean;
  isActive?: boolean;
}>`
  width: 100%;
  height: 100%;
  background-image: ${({ backgroundImage, isMobile }) =>
    backgroundImage && !isMobile ? `url(${backgroundImage})` : 'none'};
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  display: flex;
  padding-bottom: ${({ isMobile }) => (isMobile ? '16px' : '0px')};
  overflow: hidden;
  /* @media screen and (max-width: 768px) {
    overflow-x: auto;
    min-width: 600px;
    margin-right: 32px;
  } */
`;

export const Content = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  position: relative;
  z-index: 1;
  max-width: 100%;
`;

export const ImgContent = styled.div`
  position: absolute;
  bottom: 5%;
  right: 5%;
  z-index: 2;

  img {
    max-width: 350px;
    width: 100%;
    height: auto;
    object-fit: contain;
  }
`;

export const VideoContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 24px;
  margin-right: 12px;
`;

export const Grid = styled.div`
  width: 100%;
  display: grid;
  grid-template-columns: 25% 25% 25% 25%;
  // gap: 8px;
  align-items: start;
`;
